import { keymap } from '@codemirror/view';

import { LIQUID_CLOSING_TAGS, LIQUID_TAGS_REGEXP } from '@client/enums/liquid-tags';

const autoCloseLiquidTag = (view) => {
  const { state } = view;
  const cursorPos = state.selection.main.head;
  const line = state.doc.lineAt(cursorPos);
  const lineText = line.text;
  const match = LIQUID_TAGS_REGEXP.exec(lineText);

  if (match && match[1]) {
    const tagName = match[1];

    if (LIQUID_CLOSING_TAGS.includes(tagName) && !lineText.includes(`{% end${tagName} %}`)) {
      view.dispatch({
        changes: {
          from: cursorPos + 1,
          insert: `{% end${tagName} %}`
        }
      });
    }
  }
};

export const liquidAutoCloseTags = keymap.of([
  {
    key: '}',
    run: autoCloseLiquidTag,
    shift: false
  }
]);
